enum LineStyle {
	OPEN_ARROW = "OpenArrow",
	ROPEN_ARROW = "ROpenArrow",
	CLOSED_ARROW = "ClosedArrow",
	RCLOSED_ARROW = "RClosedArrow",
	BUTT = "Butt",
	SLASH = "Slash",
	CIRCLE = "Circle",
	SQUARE = "Square",
	DIAMOND = "Diamond"
}

export default LineStyle;